import { defineAsyncComponent } from 'vue'
export default {
  debug: defineAsyncComponent(() => import("/app/apps/web/src/layouts/debug.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/apps/web/src/layouts/default.vue").then(m => m.default || m)),
  "test-env": defineAsyncComponent(() => import("/app/apps/web/src/layouts/test-env.vue").then(m => m.default || m)),
  viewer: defineAsyncComponent(() => import("/app/apps/web/src/layouts/viewer.vue").then(m => m.default || m))
}